// src/components/NoticeTicker.js
import React, { useEffect, useState } from 'react';
import { checkApi } from "../../Authentication/AxiosInstance";

export const NoticeTicker = () => {
  const [notices, setNotices] = useState([]);

  const fetchNotices = async () => {
    try {
      const res = await checkApi.get("/newnotices/");
      const contentType = res.headers["content-type"];
      
      if (!contentType || !contentType.includes("application/json")) {
        console.error("❌ Not JSON:", res.data);
        throw new Error("Expected JSON, got something else.");
      }
      setNotices(res.data); // Set state here
    } catch (error) {
      if (error.response) {
        console.error("Server error response:", error.response.data);
        throw new Error(`HTTP ${error.response.status}`);
      } else {
        console.error("Network or other error:", error.message);
        throw error;
      }
    }
  };
  const truncateTitle = (text, wordLimit = 8) => {
    const words = text.split(' ');
    return words.length > wordLimit
      ? words.slice(0, wordLimit).join(' ') + '...'
      : text;
  };
  const noticeText = notices.length > 0
  ? notices.map((n, index) => (
            <span key={index}>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;***
                <strong>{n.board}</strong>: {truncateTitle(n.title)}
            </span>
    ))
  : "📭 No new notices";

 
  useEffect(() => {
    fetchNotices();
  }, []);
  console.log(notices)
  console.log(notices.length)
  
  

  return (
    <div className="flex items-center bg-yellow-200 px-4 py-2 rounded shadow-sm space-x-4">
        <div className="text-red-600 font-semibold text-sm whitespace-nowrap">
          Latest Notices &raquo;&raquo;
        </div>
        <div className="overflow-hidden flex-1">
          <div className="whitespace-nowrap animate-marquee text-gray-800 text-sm">
            {noticeText}&nbsp;&nbsp;&nbsp;***&nbsp;&nbsp;&nbsp;{noticeText}
          </div>
        </div>
  </div>
  );
};
  
